import axios from 'axios'
import qs from 'qs'
import {
    runType,
    devServer,
    proServer
} from '@/common/project-config'

axios.interceptors.request.use(
    (config) => config,
    (err) => Promise.reject(err)
)

axios.interceptors.response.use(
    (res) => Promise.resolve(res.data),
    (err) => Promise.reject(err)
)

const getUrl = (u) => {
    if (runType === 'dev') {
        return '/' + u
    } else if (runType === 'build-dev') {
        return devServer + u
    } else if (runType === 'build-pro') {
        return proServer + u
    }
}

export const requestMethod = {
    GET: Symbol('get'),
    POST: Symbol('post'),
    PUT: Symbol('put'),
    DELETE: Symbol('delete')
}

export const requestType = {
    DEFAULT: 'application/x-www-form-urlencoded',
    JSON: 'application/json',
    FILE: 'multipart/form-data'
}

export const requestDuration = {
    STANDARD: 5000,
    FILE: 30000,
    LONG: 90000
}

export const request = (config, params) => {
    let req, reqConfig = {
        headers: {
            'Content-Type': config.type || requestType.DEFAULT
        },
        timeout: config.timeout || requestDuration.STANDARD
    }
    if (config.qs) {
        params = qs.stringify(params)
    }
    switch (config.method) {
    case requestMethod.POST:
        req = axios.post(getUrl(config.url), params, reqConfig)
        break
    case requestMethod.PUT:
        req = axios.put(getUrl(config.url), params, reqConfig)
        break
    case requestMethod.DELETE:
        req = axios.delete(getUrl(config.url), {
            data: params
        }, reqConfig)
        break
    case requestMethod.GET:
    default:
        req = axios.get(getUrl(config.url), {
            params
        }, reqConfig)
        break
    }
    return req
}
